import { Stack, Typography } from '@mui/material';
import { SimpleListResult } from '@schooly/api';
import { CollapsedList } from '@schooly/style';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import { MessageCriteriaItem } from '../../../../context/messages/MessageContext';
import { MessagesModalPreviewSendToParents } from './MessagesModalPreviewSendToParents';
import { MessagesModalPreviewSendToStaff } from './MessagesModalPreviewSendToStaff';

export type MessagesModalPreviewSendToViewProps = {
  staff: SimpleListResult[];
  staffCriteria: MessageCriteriaItem[];
  staffByIndividualStudent: SimpleListResult[];
  parents: SimpleListResult[];
  parentsCriteria: MessageCriteriaItem[];
  parentsByIndividualStudent: SimpleListResult[];
  criteriaDate?: string;
};

export const MessagesModalPreviewSendToView: FC<MessagesModalPreviewSendToViewProps> = ({
  staff,
  staffCriteria,
  staffByIndividualStudent,
  parents,
  parentsCriteria,
  parentsByIndividualStudent,
  criteriaDate,
}) => {
  const { formatMessage } = useIntl();

  return (
    <Stack gap={1} pb={2}>
      {Boolean(parentsCriteria?.length || parentsByIndividualStudent?.length) && (
        <CollapsedList
          initialExpanded
          title={
            <Typography variant="h2">{formatMessage({ id: 'messages-Recipients' })}</Typography>
          }
        >
          <Stack pt={2} pb={1}>
            <MessagesModalPreviewSendToParents
              parents={parents}
              parentsCriteria={parentsCriteria}
              parentsByIndividualStudent={parentsByIndividualStudent}
              criteriaDate={criteriaDate}
            />
          </Stack>
        </CollapsedList>
      )}
      {Boolean(staffCriteria.length || staff.length) && (
        <CollapsedList
          initialExpanded
          title={<Typography variant="h2">{formatMessage({ id: 'messages-CCStaff' })}</Typography>}
        >
          <Stack pt={2}>
            <MessagesModalPreviewSendToStaff
              staff={staff}
              staffCriteria={staffCriteria}
              staffByIndividualStudent={staffByIndividualStudent}
              criteriaDate={criteriaDate}
            />
          </Stack>
        </CollapsedList>
      )}
    </Stack>
  );
};
